'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';
import { Container, GuideText, GuideImage } from './styles.js';
import Dialog from '../../Dialog/index.js';
import translations from '../translations.js';

var guideImageUrl = "https://images.vietnamworks.com/images/linkedin-guide-image-logo.png";
function GuideDialog(props) {
    var _a = __assign({}, props), isOpen = _a.isOpen, onToggleOpen = _a.onToggleOpen, _b = _a.lang, lang = _b === void 0 ? 'vi' : _b;
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var handleOnToggleOpen = function (isOpen) {
        onToggleOpen && onToggleOpen(isOpen);
    };
    var handleOnClickAction = function () {
        window && window.open('https://www.linkedin.com/in/', '_blank').focus();
        onToggleOpen && onToggleOpen('upload');
    };
    var handleOnClickCancel = function () {
        onToggleOpen && onToggleOpen('');
    };
    return (React__default.createElement(Dialog, { title: t('Import from LinkedIn'), isOpen: isOpen, onBack: function () { return handleOnToggleOpen(''); }, onClickOutside: function () { return handleOnToggleOpen(''); }, fullScreenOnMobile: true, onClickAction: handleOnClickAction, actionText: t('Open LinkedIn'), secondaryButtonText: t('Close'), onClickSecondaryButton: handleOnClickCancel, isSecondaryButtonDisabled: false, isShowSecondaryButton: true, backdrop: true, modalContainerStyle: { maxWidth: '550px', width: '100%' }, sizeButton: 'md-h' },
        React__default.createElement(Container, null,
            React__default.createElement(GuideText, null,
                t('Save your LinkedIn profile as a'),
                " ",
                React__default.createElement("b", null, t('PDF and upload it ')),
                t('to VietnamWorks. Click the'),
                " ",
                React__default.createElement("b", null, t('"More..."')),
                " ",
                t('button on your LinkedIn profile.')),
            React__default.createElement(GuideImage, { src: guideImageUrl }))));
}

export { GuideDialog as default };
//# sourceMappingURL=index.js.map
